import { faAtom } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { DefaultForm } from "../../components";
import { CommonMergeModel } from "../../entities/common";
import { useGetShareholdersSelectFilterQuery } from "../../features/board/boardSlice";

interface ShareholderMergerProps {
  mergeCallback: (data: CommonMergeModel) => Promise<boolean>;
}

export const ShareholderMerger = ({
  mergeCallback,
}: ShareholderMergerProps) => {
  const [isMerging, setIsMerging] = useState(false);

  let model: CommonMergeModel = {
    mainId: undefined,
    fakeIds: [],
  };

  const onFinish = async (values: any) => {
    let mergeModel: CommonMergeModel = {
      ...values,
    };

    setIsMerging(true);

    const isSuccess=await mergeCallback(mergeModel);

    setIsMerging(false);

    if(isSuccess) {
        // clear selected fakeIds
    }
  };

  return (
    <DefaultForm onFinish={onFinish} layout="vertical" initialValues={model}>
      <DefaultForm.DataSelect
        name="mainId"
        label="رکورد اصلی"
        placeholder="انتخاب سهامدار"
        wrapperCol={{ xs: 24, md: 18, lg: 12, xl: 6 }}
        query={useGetShareholdersSelectFilterQuery}
        displayText={(x) => `${x.name} (${x.code})`}
      />

      <DefaultForm.DataSelect
        name="fakeIds"
        label="رکوردهای جعلی"
        placeholder="انتخاب سهامداران"
        multiple={true}
        wrapperCol={{ xs: 24, lg: 12 }}
        query={useGetShareholdersSelectFilterQuery}
        displayText={(x) => `${x.name} (${x.code})`}
      />

      <DefaultForm.SubmitButton
        loading={isMerging}
        icon={<FontAwesomeIcon className="anticon" icon={faAtom} />}
      >
        ادغام
      </DefaultForm.SubmitButton>
    </DefaultForm>
  );
};
